import script from "./Post.vue?vue&type=script&setup=true&lang=js"
export * from "./Post.vue?vue&type=script&setup=true&lang=js"

import "./Post.vue?vue&type=style&index=0&id=8ef3cb9c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ef3cb9c"]])

export default __exports__